var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessAlertIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.1925 10.6925L1.6925 7.1925C1.3025 6.8025 0.6825 6.8025 0.2925 7.1925C-0.0975 7.5825 -0.0975 8.2025 0.2925 8.5925L4.4825 12.7825C4.8725 13.1725 5.5025 13.1725 5.8925 12.7825L16.4925 2.1925C16.8825 1.8025 16.8825 1.1825 16.4925 0.7925C16.1025 0.4025 15.4825 0.4025 15.0925 0.7925L5.1925 10.6925Z",
    fill: "#10B981"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessAlertIcon);
export default __webpack_public_path__ + "static/media/success_alert_icon.a35bad53c97c7239e71c939f1ecf5524.svg";
export { ForwardRef as ReactComponent };